<template>
    <Form ref="formCustom" :model="formCustom" :rules="ruleCustom" :label-width="80">
        <FormItem label="手机号码" prop="mobilenum">
            <Input v-model="formCustom.mobilenum" type="tel" placeholder="请输入11位手机号码" @on-change="showtips=false" @keyup.enter.native="userEnterKey"></Input>
        </FormItem>
        <FormItem label="验证码" prop="smscode">
            <Row>
                <Col span="15"> <Input v-model="formCustom.smscode" @on-change="showtips=false" placeholder="请输入验证码..." @keyup.enter.native="userEnterKey" /></Col>
                <Col span="9" style="text-align: right;"><Button type="text" style="background:#F0F6FF;" size="default" @click="countDown" :disabled="!this.canClick">{{content}}</Button></Col>
            </Row>
        </FormItem>
        
        <FormItem>
                <Button type="primary" style="width: 100%;" @click="handleSmsLogin('formCustom')">登录</Button>
        </FormItem>
        <!--     <FormItem>
      <Alert type="warning" show-icon :style="{display: showtips?'block':'none'}">
        <span slot="desc">{{this.errmsg}}</span>
      </Alert>
    </FormItem> -->
        <div style="text-align: center;">
            <Button type="text" @click="createAccount" style="margin:0 auto;">注册</Button>
        </div>
        <!--   <FormItem style="text-align: center;"> -->
        <!--  <Button type="text" @click="passwordReset">忘记密码？</Button> -->
        <!--    </FormItem> -->
    </Form>
</template>
<script>
import {
    reqSMSLogin
} from '../../api/security/login'
import store from '../../store/'
import regJson from '../../api/security/reg.js'
let regJ = new regJson()
export default {
    name: 'smsLogin',
    data() {
        const validateTel = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入手机号码'));
            } else {
                if (this.checkPhone(value)) {
                    callback()
                } else {
                    callback(new Error('手机号码输入有误,请重新输入.'));
                }
            }
        };
        const validateSms = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入短信验证码'));
            } else {
                callback();
            }
        };

        return {
            formCustom: {
                mobilenum: '',
                smscode: '',
                smstypecode: 0,
            },
            ruleCustom: {
                mobilenum: [
                    { validator: validateTel, trigger: 'blur' }
                ],
                smscode: [
                    { validator: validateSms, trigger: 'blur' }
                ],
            },
            showtips: false,
            errmsg: '您所提交的信息有误,请重新输入',
            content: '发送验证码',
            totalTime: 60,
            canClick: true, //添加canClick
            isSend: false,
        }
    },
    methods: {
        // handleSubmit(name) {
        //   //console.log(name)
        //   this.$refs[name].validate((valid) => {
        //     //console.log(valid)
        //     if (valid) {
        //       this.showtips = false;
        //       //this.$Message.success('密码重置成功!');
        //       //ajax 成功则关闭,并跳转至登录
        //       this.$emit('pwdok', this.formCustom);
        //       //console.log(this.formCustom);
        //     } else {
        //       //this.$Message.error('Fail!');
        //       this.showtips = true;
        //     }
        //   })
        // },
        userEnterKey() {
            this.$emit('on-enterkey')
        },
        handleReset(name) {
            this.$refs[name].resetFields();
            this.showtips = false;
        },
        checkPhone(phoneNum) {
            var phone = phoneNum;
            if (!(/^1[3|4|5|6|7|8|9]\d{9}$/.test(phone))) {
                //alert("手机号码有误，请重填");  
                return false;
            } else {
                return true;
            }
        },
        countDown() {
            if (this.isSend) {
                return
            } else {
                this.isSend = true
                //重置密码
                if (!this.checkPhone(this.formCustom.mobilenum)) {
                    this.errmsg = "电话号码有误,请修改";
                    this.showtips = true;
                    this.isSend = false
                    return
                }
                this.formCustom.smstypecode = this.$Tools.getSMSFrom().SMS_CODE_TYPE_MOBILE_LOGIN
                regJ.reqSmsCode(this.formCustom.mobilenum, this.formCustom.smstypecode).then(res => {
                    this.isSend = false
                    console.log(this.formCustom.mobilenum)
                    if (res.rtncode === 1) {
                        if (res.rltcode === 1) {
                            this.$Message.info('验证码已发送')
                            console.log('验证码已发送')

                        } else {
                            console.log(res)
                            this.$Message.error(res.rltdesc);
                            return
                        }
                    } else {
                        console.log(res)
                        this.$Message.error(res.rtndesc);
                        return
                    }

                    if (!this.canClick) return //改动的是这两行代码
                    this.canClick = false
                    this.content = this.totalTime + 's后重新发送'
                    let clock = window.setInterval(() => {
                        this.totalTime--
                        this.content = this.totalTime + 's后重新发送'
                        if (this.totalTime < 0) {
                            window.clearInterval(clock)
                            this.content = '发送验证码'
                            this.totalTime = 60
                            this.canClick = true //这里重新开启
                        }
                    }, 1000)


                })

            }

        },
        handleSmsLogin(name) {
            var that = this
            console.log(name)
            console.log(this.formCustom)
            this.$refs[name].validate((valid) => {
                console.log(valid)
                if (valid) {
                    this.$emit('on-valid-success')
                    var payload = {
                        mobilenum: this.formCustom.mobilenum,
                        tempid: store.state.user.userGuid,
                        smscode: this.formCustom.smscode
                    }
                    //console.log(payload)
                    // store._actions.handleLogin[0](payload)
                    //   .then(res => {
                    //     this.showtips = false;
                    //     this.$Message.success('登录成功!');
                    //     this.$emit('loginok');
                    //   })
                    //   .catch(err => {
                    //     this.$Message.error(err);
                    //     this.$emit('loginerr');
                    //   })
                    // regJ.
                    reqSMSLogin(payload).then(function(resp) {
                        // console.log(that)
                        console.log(resp)
                        if (resp.rtncode === 1) {
                            if (resp.rltcode === 1) {
                                console.log('SMSLogin success...')
                                var loginUser = {
                                    userGuid: resp.userguid,
                                    userId: resp.userid,
                                    mobileNum: resp.mobilenum,
                                    realName: resp.realname,
                                    token: resp.token,

                                    userType: resp.userid,
                                    permission: resp.permission,
                                    accounttype: resp.accounttype,
                                    accountstatus: resp.accountstatus,
                                    freefolder: resp.freefolder,
                                    showmsg: resp.showmsg,
                                    wxopenid: resp.wxopenid,
                                    wxunionid: resp.wxunionid,
                                    wxgenerateid: resp.wxgenerateid,
                                    showmallbutton: resp.showmallbutton,
                                    mallver: resp.mallver,
                                    iseditacc: resp.isallowedituserid,
                                    isupbaseproductnotice:resp.isupbaseproductnotice,
                                    maxopendocnum:resp.maxopendocnum,
                                    opendocnum:resp.opendocnum,
                                    email:resp.email
                                }
                                console.log(loginUser)
                                that.showtips = false;
                                that.$Message.success('登录成功！');
                                store.commit('setLoginUser', loginUser)
                                that.$emit('loginok');

                            } else {
                                that.$Modal.info({
                                    title: '提示',
                                    content: resp.rltdesc
                                });
                                //that.$Message.error(resp.rltdesc)
                                that.$emit('loginerr');
                            }
                        } else {
                            that.$Modal.info({
                                title: '提示',
                                content: resp.rtndesc
                            });
                            //that.$Message.error(resp.rtndesc)
                            that.$emit('loginerr');
                        }
                    }).catch(function(err) {
                        that.$Message.error(err);
                        that.$emit('loginerr');
                    })



                } else {
                    that.showtips = true;
                    that.$emit('loginerr');
                    //this.$Message.error('验证失败!');
                    console.log("验证失败")
                }
            })

        },
        createAccount() {
            this.$emit('createAccount');
        },
        passwordReset() {
            this.$emit('pwdReset');
        },
    },

}
</script>
<style scoped>
</style>